import * as React from "react";
import { useEffect } from "react";
import { PatientRoute } from "../../../PatientRoutes/PatientRoute";
import { usePatientRouteChanger } from "../../../PatientRoutes/routeChanger";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useClinicData } from "../../../clinic/clinicHooks";

export const WhatsNextViewSummary = () => {
  const routeChanger = usePatientRouteChanger();
  const { name: clinicName, clinic: clinicId } = useClinicData();
  useEffect(() => {
    evt({
      category: CATEGORY.PATIENT_RESULT,
      action: ACTION.PATIENT_WHATS_NEXT,
      label: `View summary clicked`,
      props: {
        clinicName,
        clinicId,
      },
    });
    routeChanger(PatientRoute.Summary, { backto: PatientRoute.Result });
  }, [routeChanger, clinicName, clinicId]);

  return <div />;
};
